<template>
    <div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Tabs value="1">
            <TabPane label="基础信息" name="1">
            <Form label-position="left" :label-width="80" >
                <FormItem label="id: " v-if="data.id">
                    <Input v-model="data.id" disabled></Input>
                </FormItem>
                <FormItem label="赛事: ">
                    <uniqueTournamentSearch v-model="data.unique_tournament" :sport_id="sport_id" :classname="locks[String(type)+'-1-'+'unique_tournament_id'] === 1? 'locked-input': '' "></uniqueTournamentSearch>
                </FormItem>
                <FormItem label="赛季: ">
                    <seasonSearch v-model="data.season_id" :sport_id="sport_id" :unique_tournament_id="data.unique_tournament.id" :classname="locks[String(type)+'-1-'+'season_id'] === 1? 'locked-input': '' "></seasonSearch>
                </FormItem>

                <FormItem label="荣誉年份: ">
                    <Input v-model="data.season" :class="locks[String(type)+'-1-'+'season'] === 1? 'locked-input': '' " ></Input>
                </FormItem>
                <!-- <FormItem label="月&周: ">
                    <HonorMonthWeek :month="data.month" :week="data.week" @update:month="data.month = $event" @update:week="data.week = $event"></HonorMonthWeek>
                </FormItem> -->
                <FormItem label="荣誉: ">
                    <honorSearch v-model="data.honor" :sport_id="sport_id" :classname="locks[String(type)+'-1-'+'player'] === 1? 'locked-input': '' "></honorSearch>
                </FormItem>
                <FormItem label="球队: ">
                    <teamSearch v-model="data.team" :sport_id="sport_id" :classname="locks[String(type)+'-1-'+'team'] === 1? 'locked-input': '' "></teamSearch>
                </FormItem>
                
                <FormItem label="是否删除: ">
                    <Select v-model="data.deleted" :class="locks[String(type) + '-1-' + 'deleted'] === 1? 'locked-select': '' ">
                        <Option :value="1" key="1">是</Option>
                        <Option :value="0" key="0">否</Option>
                    </Select>
                </FormItem>
            </Form>
            </TabPane>
        </Tabs>
        <Row align="middle">
            <Button type="primary"  @click="save" long size="default">保存</Button>
        </Row>
    </div>
</template>
<script>

import uniqueTournamentSearch from '@/components/ballsports/unique_tournament/search.vue';
import seasonSearch from '@/components/ballsports/season/search.vue';
import honorSearch from '@/components/ballsports/honor/search.vue';
import teamSearch from "@/components/ballsports/team/search.vue";
// import HonorMonthWeek from "@/components/basic/honor_month_week.vue"
import { FormItem } from 'view-design';
import { getUniqueTournamentChampionList, updateUniqueTournamentChampion} from '@/api/ballsports/base/unique_tournament';


export default {
    name: "championEdit",
    props: {
        sport_id: Number,   // 运动id
        row_id: Number,   // 联赛id
    },
    components: {
        teamSearch,
        uniqueTournamentSearch,
        seasonSearch,
        honorSearch,
        // HonorMonthWeek,
    },
    data () {
        let self = (window.x = this)
        return {
            obj_type: 7,  // 战队
            type: 1,     // 基本数据
            spinShow: false,
            data: {
                id: 0,
                sport_id: self.sport_id,
                name:'',
                unique_tournament: {},
                season_id: {},
                team: {},
                honor: {},
                deleted: 0,
                month: 0,
                week: 0,
            },
            locks: {},
            new_team: {
                "id": 0,
                "name": '',
                "logo": '',
            },
        }
    },
    methods: {
        getData () {
            let self = this;
            if (self.row_id && self.row_id > 0){
                this.spinShow = true;
                // 搜索日期
                var params = {
                    sport_id: this.sport_id,
                    "id" : this.row_id,
                }
                getUniqueTournamentChampionList( params ).then(response => {
                    if (response.data.code == 0) {
                        if (response.data.data.list && response.data.data.list.length > 0){
                            this.data = response.data.data.list[0];
                            // self.locks = response.data.data.locks ;
                            self.locks = {}
                        }else{
                            this.data = {}
                            self.locks = {}
                        }
                        self.spinShow = false
                    } else {
                        self.$Message.error(response.data.msg)
                    }
                })
            }else{
                self.locks = {}
                self.data = {
                    id: 0,
                    sport_id: self.sport_id,
                    unique_tournament: {},
                    season_id: {},
                    team: {},
                    honor: {},
                    deleted: 0,
                    month: 0,
                    week: 0,
                }
            }
        },
        // end 
        emit(func_name){
            this.$emit('closePage', func_name)
        },

        save() {
            let self = this;
            let home_team_ids = []
            if (self.data.home_teams && self.data.home_teams.length > 0){
                self.data.home_teams.forEach(element => {
                    home_team_ids.push(element.id)
                });
            }

            let params = {
                id: self.data.id,
                sport_id: self.data.sport_id || self.sport_id,
                honor_id: self.data.honor.id,
                team_id: self.data.team.id,
                season: self.data.season,
                competition_id: self.data.unique_tournament.id,
                season_id: self.data.season_id.id,
                deleted: self.data.deleted,
                // month: self.data.month,
                // week : self.data.week,
            }
            updateUniqueTournamentChampion(params).then(response => {
                if (response.data.code == 0) {
                    this.$Message.success("保存成功")
                    self.emit("save")
                } else {
                    this.$Message.error(response.data.msg)
                }
            })
            
        },
        // end
    },
    mounted () {
        // let self = this;
        // self.getData();
    },
    watch: {
        "row_id":{
            handler(value){
                let self = this;
                if (value >= 0){
                    // console.log("Detail Get Data", value);
                    // self.getCategorys();
                    self.getData();
                };
            },
	        immediate: true,  // 深度触发
        }
    },
    computed: {
    }
}
</script>

<style scoped>
    /* @import "detail.css" */
</style>